module.exports = __webpack_public_path__ + "img/thinkImg.3b2988b0.gif";